import {
  PayoutDestinationType,
  PayoutTransferDestination
} from "@wingspanhq/wingspan-api-sdk";

export const getDestinationName = (
  destination: PayoutTransferDestination
): string => {
  const { institutionName, name, mask } = destination;

  if (!institutionName && !name && !mask) {
    switch (destination.type) {
      case PayoutDestinationType.PAYMENT_CARD:
        return "Debit Card";
      case PayoutDestinationType.GIFT_CARD:
        return "WeGift Gift Card";

      case PayoutDestinationType.EXTERNAL_BANK_ACCOUNT:
      default:
        return "Bank Account";
    }
  }

  let details = `${institutionName || ""} ${name || ""}`.trim();
  if (mask) {
    details += ` (...${mask})`;
  }

  return details;
};
